var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-hire-wrapper"},[_c('button',{attrs:{"href":"/contact"},on:{"click":function($event){$event.preventDefault();return _vm.goToContact($event)}}},[_vm._v("Hire Us"),_c('span',{staticClass:"line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }